import { render, staticRenderFns } from "./chat-item-order.vue?vue&type=template&id=5d1d3a70"
import script from "./chat-item-order.vue?vue&type=script&lang=js"
export * from "./chat-item-order.vue?vue&type=script&lang=js"
import style0 from "./chat-item-order.vue?vue&type=style&index=0&id=5d1d3a70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports